import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { SmoothScroll } from "./components/layout/SmoothScroll";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { Toaster } from "./components/ui/sonner";

import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import QuotePage from "./pages/QuotePage";
import CustomOrdersPage from "./pages/CustomOrdersPage";
import BlogListPage from "./pages/BlogListPage";
import BlogPostPage from "./pages/BlogPostPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminForgotPasswordPage from "./pages/admin/AdminForgotPasswordPage";
import AdminResetPasswordPage from "./pages/admin/AdminResetPasswordPage";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";

function SiteLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll>
            <div className="App">
              <Toaster position="top-right" />
              <Routes>
                <Route path="/" element={<SiteLayout><HomePage /></SiteLayout>} />
                <Route path="/catalog" element={<SiteLayout><CatalogPage /></SiteLayout>} />
                <Route path="/parts/:sku" element={<SiteLayout><ProductDetailPage /></SiteLayout>} />
                <Route path="/quote" element={<SiteLayout><QuotePage /></SiteLayout>} />
                <Route path="/custom-orders" element={<SiteLayout><CustomOrdersPage /></SiteLayout>} />
                <Route path="/blog" element={<SiteLayout><BlogListPage /></SiteLayout>} />
                <Route path="/blog/:slug" element={<SiteLayout><BlogPostPage /></SiteLayout>} />
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin/forgot-password" element={<AdminForgotPasswordPage />} />
                <Route path="/admin/reset-password" element={<AdminResetPasswordPage />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboardPage />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </div>
          </SmoothScroll>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
